import type { Control, FieldErrors, UseFormWatch } from "react-hook-form";
import { Controller } from "react-hook-form";
import { FormFieldController } from "../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import type {
  SiteSetupProcessForForm,
  TenantTableErrors
} from "../../SiteSetupAssistant.types";
import { TenantTable } from "../CustomFields/TenantTable/TenantTable";
import { SITE_SETUP_ASSISTANT_FORM } from "../SiteSetupAssistantForms.constants";

interface TenantAddressAndParticipationSectionProps {
  formControl: Control<SiteSetupProcessForForm>;
  formErrors: FieldErrors<SiteSetupProcessForForm>;
  participationAndAddressSet: boolean;
  tenantTableErrors: TenantTableErrors | null;
  onBlockNavigation: (isBlocked: boolean) => void;
  watch: UseFormWatch<SiteSetupProcessForForm>;
}

export function TenantAddressAndParticipationSection({
  formControl,
  formErrors,
  participationAndAddressSet,
  tenantTableErrors,
  onBlockNavigation,
  watch
}: TenantAddressAndParticipationSectionProps) {
  return (
    <div className="TenantFormItems site-setup-assistant-form">
      <FormFieldController
        control={formControl}
        data={{
          ...SITE_SETUP_ASSISTANT_FORM.allTenantAddressesAreSameAsSiteAddress,
          disabled: !!participationAndAddressSet
        }}
        error={formErrors.allTenantAddressesAreSameAsSiteAddress}
      />
      <FormFieldController
        control={formControl}
        data={{
          ...SITE_SETUP_ASSISTANT_FORM.allTenantsParticipatingInMieterstrom,
          disabled: !!participationAndAddressSet
        }}
        error={formErrors.allTenantsParticipatingInMieterstrom}
      />
      {participationAndAddressSet && (
        <Controller
          control={formControl}
          name="consumers"
          render={({ field }) => {
            return (
              <TenantTable
                consumers={field.value}
                defaultMeasurementType={
                  watch("connectionMeasurementType") || null
                }
                tenantTableErrors={tenantTableErrors}
                onBlockNavigation={onBlockNavigation}
                onChange={field.onChange}
              />
            );
          }}
        />
      )}
    </div>
  );
}
